/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/prop-types */
import React from 'react';

import dateIconDisable from '@/assets/icons/date-disable.svg';
import dateIconEnable from '@/assets/icons/date-enable.svg';
import lefIcon from '@/assets/icons/left-sign.svg';
import rightIcon from '@/assets/icons/right-sign.svg';
import DateTime from '@/components/dateTimePicker/DateTimePicker';
import ToggleButton from '@/components/togglebutton/src/ToggleButtonCustom';
import {HISTORY_SHOW_TYPE, HISTORY_SHOW_TYPE_DATE_OPTION} from '@/constants/enums';

import './BottomMenuCalibHistory.less';

// TODO the history bottom menu could separate into common component that handle the history date selector @see {@link CycleHistoryBottomMenu}
function BottomMenuCalibrationHistory(props) {
  const iconShowTypeDate = props.showType === HISTORY_SHOW_TYPE.DATE ? dateIconEnable : dateIconDisable;
  const showType = [
    {
      label: HISTORY_SHOW_TYPE.DATE,
      value: HISTORY_SHOW_TYPE.DATE,
      icon: iconShowTypeDate,
      onClick: props.onClick,
      customButtonSize: true,
    },
    {
      label: HISTORY_SHOW_TYPE.ALL,
      value: HISTORY_SHOW_TYPE.ALL,
      onClick: props.onClick,
      customButtonSize: true,
    },
  ];
  const disableDateAction = props.showType !== HISTORY_SHOW_TYPE.DATE;
  return (
    <div className="calibrationHistoryBottomMenu center footer">
      <button
        type="button"
        id={HISTORY_SHOW_TYPE_DATE_OPTION.OLDER}
        onClick={props.onClick}
        className="newerButton center"
        disabled={disableDateAction}
      >
        <img
          src={lefIcon}
          alt={lefIcon}
        />
        &nbsp;
        {HISTORY_SHOW_TYPE_DATE_OPTION.OLDER}
      </button>

      <input
        className="searchFilter"
        id={HISTORY_SHOW_TYPE_DATE_OPTION.SEARCH_FILTER}
        onClick={props.onClick}
        value={props.searchFilter.toLocaleDateString('en-US', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
        })}
        readOnly
        disabled={disableDateAction}
      />

      <div className="show-type">
        <ToggleButton
          buttonProp={showType}
          defaultValue={HISTORY_SHOW_TYPE.ALL}
          value={props.showType}
          onClick={props.onClick}
          disabled={false}
        />
      </div>

      <button
        type="button"
        id={HISTORY_SHOW_TYPE_DATE_OPTION.NEWER}
        onClick={props.onClick}
        className="olderButton center"
        disabled={disableDateAction}
      >
        {HISTORY_SHOW_TYPE_DATE_OPTION.NEWER}&nbsp;
        <img
          src={rightIcon}
          alt={rightIcon}
        />
      </button>

      <DateTime
        id={props.id}
        showDateTime={props.showDateTime}
        onClose={props.onCloseDatePicker}
        dateFormat={props.dateFormat}
        timeFormat={props.timeFormat}
        value={props.valueDateTimePopup}
      />
    </div>
  );
}
export default BottomMenuCalibrationHistory;
